import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Line } from 'react-chartjs-2';

// Config.
import { chart } from '../../config';

// Components.
import Legend from './Legend';

// Siblings.
import './chartPluginsRegister';
import './styles.css';

//------------------------------------------------------------------------------

const Chart = ({ className, data, options }) => {
  const classNameRoot = classNames('Chart', className);
  const legendData = [...chart.legend].reverse();
  return (
    <div className={classNameRoot}>
      <div className="ChartWrapper">
        <Line data={data} options={options} />
      </div>
      <Legend data={legendData} />
    </div>
  );
};

Chart.propTypes = {
  className: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  options: PropTypes.objectOf(PropTypes.any),
};

Chart.defaultProps = {
  className: null,
  options: chart.options,
};

export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart/index.js